export default __webpack_public_path__ + "static/media/005.4ee8d285.jpg";